import React from 'react';
import GamingPage from '@src/components/gaming-page/Gaming';
import Head from 'next/head';
import { PREVIEW_IMAGES_CDN } from 'util/constants';
import type { GetStaticProps } from 'next';

export const Gaming = () => {
  return (
    <>
      <Head>
        <title>Gaming - Ozone Metaverse Platform</title>
        <meta
          name='description'
          content='Open world, PvP battles, AI-driven gameplay, and blockchain economy - THE ARENA by OZONE is redefining online gaming!'
        />
        <meta property='og:title' content='Gaming - Ozone Metaverse Platform' />
        <meta
          property='og:description'
          content='Open world, PvP battles, AI-driven gameplay, and blockchain economy - THE ARENA by OZONE is redefining online gaming!'
        />
        <meta property='og:url' content='https://ozonemetaverse.io/gaming' />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content={`${PREVIEW_IMAGES_CDN}/preview-gaming.jpg`}
        />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
        <meta
          name='twitter:title'
          content='Gaming - Ozone Metaverse Platform'
        />
        <meta
          name='twitter:description'
          content='Open world, PvP battles, AI-driven gameplay, and blockchain economy - THE ARENA by OZONE is redefining online gaming!'
        />
        <meta
          name='twitter:image'
          content={`${PREVIEW_IMAGES_CDN}/preview-gaming.jpg`}
        />
        <meta name='twitter:card' content='summary_large_image' />
      </Head>
      <style global>
        {`
          .content {
            background-image: none;
            overflow: hidden;
            min-height: auto;
          }
        `}
      </style>
      <GamingPage />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default Gaming;
